import styled from "styled-components/macro";
import { ChevronRight } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9 !important;
    &:hover {
      cursor: pointer;
    }
  }
`;

export const StyledSelectCalcRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5em 1em;
  box-sizing: border-box;
  min-height: 75px;
`;

export const LineItemRowContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  width: 100%;
  box-sizing: border-box;
  min-height: 75px;
`;

export const StyledIconButton = styled(IconButton)`
  && {
    width: 18px !important;
    padding: 0;
    background: none;
    border: none;
    margin-right: 1.2em;
    margin-left: 0.7em;
  }

  &:hover {
    background: none !important;
  }
`;

export const LineItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const LBRowDebtString = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 0.7em;
  text-transform: uppercase;
`;

export const LBRowDerivedString = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #5f6368;
`;

export const SourceFileTypeWrapper = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
`;

export const UploadDateWrapper = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
  padding-top: 5px;
`;

export const PropertyNameWrapper = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  color: #5f6368;
  padding-top: 5px;
`;
